function showDropdownMasks() {
    if(window.innerWidth >= 1024) return;
    const dropdown = document.getElementsByClassName("menu-dropdown--masks")[0];

    if(dropdown.style.display == "") {
        dropdown.style.display = "flex";
        document.getElementById("nav__icon--masks").src = "https://cdn.shopify.com/s/files/1/0261/5404/1406/files/collapse-icon.svg"
    } else {
        dropdown.style.display = "";
        document.getElementById("nav__icon--masks").src = "https://cdn.shopify.com/s/files/1/0261/5404/1406/files/expand-icon.svg"
    }
}

function showDropdownHats() {
    if(window.innerWidth >= 1024) return;
    const dropdown = document.getElementsByClassName("menu-dropdown--hats")[0];

    if(dropdown.style.display == "") {
        dropdown.style.display = "flex";
        document.getElementById("nav__icon--hats").src = "https://cdn.shopify.com/s/files/1/0261/5404/1406/files/collapse-icon.svg"
    } else {
        dropdown.style.display = "";
        document.getElementById("nav__icon--hats").src = "https://cdn.shopify.com/s/files/1/0261/5404/1406/files/expand-icon.svg"
    }
}

function showMobileMenu() {
    if(window.innerWidth >= 1024) return;
    const nav = document.getElementsByClassName("nav")[0];
    nav.style.display = nav.style.display == "flex" ? "none" : "flex";
}

function onResize() {
    if(window.innerWidth >= 1024) {
        document.getElementsByClassName("nav")[0].style.display = "flex";
        var collapseIcon = 'https://cdn.shopify.com/s/files/1/0261/5404/1406/files/collapse-icon.svg';
    } else {
        document.getElementsByClassName("nav")[0].style.display = "none";
    }
}

if(window.innerWidth < 1024) {
    document.getElementsByClassName("nav")[0].style.display = "none";
    document.getElementById("nav__icon").src = "https://cdn.shopify.com/s/files/1/0261/5404/1406/files/expand-icon.svg"
}
window.addEventListener("resize", onResize);